export const enum MemberLevel {
  ADMIN = 'Admin',
  DEVELOPER = 'Developer',
}

export const enum MemberStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
}
